import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { getEscalatedTickets } from "../../../services/supportApi";

const MyTickets = () => {
  const navigate = useNavigate();
  const [page] = useState(1);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["support-escalations", "my-tickets", page],
    queryFn: () => getEscalatedTickets("assigned_backoffice", page, 20),
  });

  const tickets = data?.data?.tickets || [];

  return (
    <div className="ticket-list">
      {isLoading && <p>Loading your tickets...</p>}
      {isError && <p>Error loading your tickets.</p>}

      {!isLoading && !isError && tickets.length === 0 && (
        <p>You have no assigned tickets.</p>
      )}

      {!isLoading && !isError && tickets.length > 0 && (
        <table className="ticket-table">
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Customer</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((ticket) => (
              <tr key={ticket._id || ticket.ticketId}>
                <td>{ticket.ticketId}</td>
                <td>{ticket.customerName || "N/A"}</td>
                <td>{ticket.priority || "Normal"}</td>
                <td>{ticket.status}</td>
                <td>
                  <button
                    onClick={() =>
                      navigate(`/BOD/support-escalations/${ticket.ticketId}`)
                    }
                    className="view-btn"
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MyTickets;
